module.exports = __webpack_public_path__ + "static/img/evpg-visualization.2483140.gif";